import { render, staticRenderFns } from "./LastSpot.vue?vue&type=template&id=a3142c54&scoped=true&"
import script from "./LastSpot.vue?vue&type=script&lang=js&"
export * from "./LastSpot.vue?vue&type=script&lang=js&"
import style0 from "./LastSpot.vue?vue&type=style&index=0&id=a3142c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3142c54",
  null
  
)

export default component.exports